import { ContestContestantsResult, ContestJudgesResult } from '../../components/manager/types';
import serverApi from '../serverApi';
import createDummyContests from './dummyData/dummyContests';
import { Contest, ContestRead, PaginatedContests } from './types';

const contestsEndpoint = '/api/judge/contests';
const usersEndpoint = '/api/user';
const contestUsersEndpoint = `${usersEndpoint}/contest-users`;

const getContestData = async (contestSlugOrId: string | number) => {
	return (await serverApi.get(`${contestsEndpoint}/${contestSlugOrId}/`)).data as ContestRead;
};

const getContests = async (params: { limit?: number; offset?: number }) => {
	return (
		await serverApi.get(`${contestsEndpoint}/`, {
			params,
		})
	).data as PaginatedContests;
};

const getPaginatedContests = async () => {
	return createDummyContests() as PaginatedContests; // TODO: Remove when api integrated
	return (await serverApi.get(`${contestsEndpoint}/`)).data as PaginatedContests;
};

const createNewContest = async (contest: Contest) => {
	return (await serverApi.post(`${contestsEndpoint}/`, contest)).data as Contest;
};

const editContest = async (contestId: number, contest: Contest) => {
	return (await serverApi.patch(`${contestsEndpoint}/${contestId}/`, contest)).data as Contest;
};

const getJudgesOfAContest = async (contestId: number | undefined) => {
	return (await serverApi.get(`${contestUsersEndpoint}/contest/${contestId}/judges/`)).data as ContestJudgesResult;
};

const getContestantsOfAContest = async (
	contestId: number | undefined,
	params?: { limit?: number; offset?: number; username?: string; email?: string; institution?: string },
) => {
	return (await serverApi.get(`${contestUsersEndpoint}/contest/${contestId}/contestants/`, { params }))
		.data as ContestContestantsResult;
};

const resetPasswordOfAContestant = async (userId: number) => {
	return (await serverApi.post(`${contestUsersEndpoint}/${userId}/reset-password/`)).data;
};

const suspendUserAccount = async (userId: number) => {
	return (await serverApi.post(`${contestUsersEndpoint}/${userId}/disable/`)).data;
};

const activateUserAccount = async (userId: number) => {
	return (await serverApi.post(`${contestUsersEndpoint}/${userId}/enable/`)).data;
};

const banUserAccount = async (userId: number) => {
	return (await serverApi.post(`${contestUsersEndpoint}/${userId}/ban/`)).data;
};

const unbanUserAccount = async (userId: number) => {
	return (await serverApi.post(`${contestUsersEndpoint}/${userId}/unban/`)).data;
};

const addJudgeToAContest = async (contestId: number | undefined, user: number) => {
	return (
		await serverApi.post(`${contestUsersEndpoint}/contest/${contestId}/add-user/`, {
			user,
			role: 'JUDGE',
		})
	).data;
};

const removeJudgeFromContest = async (contestId: number | undefined, user: number) => {
	return (
		await serverApi.post(`${contestUsersEndpoint}/contest/${contestId}/remove-user/`, {
			user,
			role: 'JUDGE',
		})
	).data;
};

const searchUsers = async (query: string) => {
	return (await serverApi.get(`${usersEndpoint}/users?search=${query}&limit=5&offset=0`)).data;
};

const getFirstSolvers = async (contestId: number) => {
	return (
		await serverApi.get(`/api/judge/contest-balloon/first-solvers/`, {
			params: { contest: contestId },
		})
	).data;
};

const downloadBalloonCsv = async (contestId: number, startDatetime: string, endDatetime: string) => {
	const response = await serverApi.get(`/api/judge/contest-balloon/csv/`, {
		params: {
			contest: contestId,
			start_datetime: startDatetime,
			end_datetime: endDatetime,
		},
		responseType: 'blob',
	});
	return response.data as Blob;
};

export {
	getContestData,
	getContests,
	getPaginatedContests,
	createNewContest,
	editContest,
	getJudgesOfAContest,
	getContestantsOfAContest,
	addJudgeToAContest,
	removeJudgeFromContest,
	searchUsers,
	resetPasswordOfAContestant,
	suspendUserAccount,
	activateUserAccount,
	banUserAccount,
	unbanUserAccount,
	getFirstSolvers,
	downloadBalloonCsv,
};
